export default __webpack_public_path__ + "static/image05-e16777a276d9ec05cdd452cd19a545cf.webp";